import {Component, TemplateRef} from '@angular/core';
import {NgbToast} from "@ng-bootstrap/ng-bootstrap";
import {NgIf, NgForOf, NgTemplateOutlet} from '@angular/common';
import {ToastService} from "../../services/toast.service";

@Component({
  selector: 'app-toasts-component',
  standalone: true,
  imports: [
    NgbToast, NgIf, NgForOf, NgTemplateOutlet
  ],
  templateUrl: './toasts-component.component.html',
  styleUrl: './toasts-component.component.scss'
})
export class ToastsComponentComponent {
  hide = false;

  constructor(public toastService: ToastService) {}

  isTemplate(toast: { textOrTpl: any; }) { return toast.textOrTpl instanceof TemplateRef; }
}
